// extracted by mini-css-extract-plugin
export default {"headingH2":"spares_headingH2__Yg4GV","breadcrumbs":"spares_breadcrumbs__FL+Y+","aboutp":"spares_aboutp__rS+Hv","aboutH3":"spares_aboutH3__wqwXQ"};